import { render } from "./icon-button.vue?vue&type=template&id=81bd5e02"
import script from "./icon-button.vue?vue&type=script&lang=js"
export * from "./icon-button.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_b6f5290c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__